import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { SimpleWrapper } from "../InputsMex/containers";
import { TextInput } from "../InputsMex/inputs";

const FormCambiarContrasenia = ({ onSubmit, errorMsg, showError, names, labelBtn }) => {
  const methods = useForm({ mode: "onChange" });
  const { watch, handleSubmit } = methods;

  if (!names) {
    return "NO SE HA PASADO LA VARIABLE names";
  }

  const { actual, uno, dos } = names;

  return (
    <FormProvider {...methods}>
      <form autoComplete='off' noValidate onSubmit={handleSubmit(onSubmit)}>
        {actual && (
          <SimpleWrapper label='Ingrese su contraseña actual' name={actual.name}>
            <TextInput
              inputProps={{
                name: actual.name,
                placeholder: "Ingrese su contraseña actual",
                type: "current-password",
              }}
              extrasClasses='pass-input'
              rules={actual.rules}
            />
          </SimpleWrapper>
        )}

        {uno && (
          <SimpleWrapper label='Ingrese su nueva contraseña' name={uno.name}>
            <TextInput
              inputProps={{
                name: uno.name,
                placeholder: "Ingrese su nueva contraseña",
                type: "new-password",
              }}
              extrasClasses='pass-input'
              rules={{
                ...uno.rules,
                validate: uno.rules.validate && uno.rules.validate(watch),
              }}
            />
          </SimpleWrapper>
        )}

        {dos && (
          <SimpleWrapper label='Confirme su nueva contraseña' name={dos.name}>
            <TextInput
              inputProps={{
                name: dos.name,
                placeholder: "Confirme su nueva contraseña",
                type: "new-password",
              }}
              extrasClasses='pass-input'
              rules={{
                ...dos.rules,
                validate: dos.rules.validate && dos.rules.validate(watch),
              }}
            />
          </SimpleWrapper>
        )}

        {showError && (
          <div className='text-center mt-2 text-danger'>
            <span className='font-mex msg-error'>{errorMsg}</span>
          </div>
        )}
        <div className='row mt-3 justify-content-center'>
          <div className='col-10'>
            <button className='btn btn-block btn-mex' type='submit'>
              {labelBtn || "Cambiar Contraseña"}
            </button>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default FormCambiarContrasenia;
